import * as actionTypes from "../actionTypes";

export const getOrderSettings = (payload) => ({
  type: actionTypes.GET_ORDER_SETTINGS,
});

export const saveOrderSettings = (payload) => ({
  type: actionTypes.SAVE_ORDER_SETTINGS,
  payload,
});

export const postOrderSettings = (payload) => ({
  type: actionTypes.POST_ORDER_SETTINGS,
  payload,
});

export const getOrderTransferData = () => ({
  type: actionTypes.GET_ORDER_TRANSFER_DATA,
});

export const saveOrderTransferData = (payload) => ({
  type: actionTypes.SAVE_ORDER_TRANSFER_DATA,
  payload,
});

export const getSecondAccounts = (payload) => ({
  type: actionTypes.GET_SECOND_ACCOUNTS,
  payload,
});

export const saveOrderTransferSecondaryAccounts = (payload) => ({
  type: actionTypes.SAVE_ORDER_TRANSFER_SECONDARY_ACCOUNT,
  payload,
});

export const addTransferAccount = (payload) => ({
  type: actionTypes.ADD_TRANSFER_ACCOUNT,
  payload,
});
export const getTransferAccountEditDetails = (payload) => ({
  type: actionTypes.GET_TRANSFER_ACCOUNT_EDIT_DETAILS,
  payload,
});
export const saveTransferAccountEditDetails = (payload) => ({
  type: actionTypes.SAVE_TRANSFER_ACCOUNT_EDIT_DETAILS,
  payload,
});
export const editTransferAccount = (payload) => ({
  type: actionTypes.EDIT_TRANSFER_ACCOUNT,
  payload,
});
export const postOrderTransferData = (payload) => ({
  type: actionTypes.POST_ORDER_TRANSFER_DATA,
  payload,
});

export const updateTransferAccountStatus = (payload) => ({
  type: actionTypes.UPDATE_TRANSFER_ACCOUNT_STATUS,
  payload,
});

export const getOnlifeData = (payload) => ({
  type: actionTypes.GET_ON_LIFE_DATA,
  payload,
});

export const saveOnlifeData = (payload) => ({
  type: actionTypes.SAVE_ON_LIFE_DATA,
  payload,
});

export const postMerchantOnlifeData = (payload) => ({
  type: actionTypes.POST_MERCHANT_ON_LIFE_DATA,
  payload,
});
export const postCompetitorOnlifeData = (payload) => ({
  type: actionTypes.POST_COMPETITOR_ON_LIFE_DATA,
  payload,
});
export const deleteCompetitorOnlifeData = (payload) => ({
  type: actionTypes.DELETE_COMPETITOR_ON_LIFE_DATA,
  payload,
});

// pos master
export const getPosMasterData = (payload) => ({
  type: actionTypes.GET_POS_MASTER_DATA,
  payload,
});

export const savePosMasterData = (payload) => ({
  type: actionTypes.SAVE_POS_MASTER_DATA,
  payload,
});

export const postAddPosMasterFormData = (payload) => ({
  type: actionTypes.POST_ADD_POS_MASTER_FORM_DATA,
  payload,
});
export const postPosMasterActiveStatus = (payload) => ({
  type: actionTypes.POST_POS_MASTER_ACTIVE_STATUS,
  payload,
});
export const getPosMasterFormOptions = (payload) => ({
  type: actionTypes.GET_POS_MASTER_FORM_OPTIONS,
  payload,
});
export const savePosMasterFormOptions = (payload) => ({
  type: actionTypes.SAVE_POS_MASTER_FORM_OPTIONS,
  payload,
});
export const getEditPosMasterFormData = (query) => ({
  type: actionTypes.GET_EDIT_POS_MASTER_FORM_DATA,
  query,
});
export const saveEditPosMasterFormData = (payload) => ({
  type: actionTypes.SAVE_EDIT_POS_MASTER_FORM_DATA,
  payload,
});
export const postEditPosMasterFormData = (payload) => ({
  type: actionTypes.POST_EDIT_POS_MASTER_FORM_DATA,
  payload,
});
export const postPosIntegrationSetting = (payload) => ({
  type: actionTypes.POST_POS_INTEGRATION_SETTING,
  payload,
});
export const savePosIntegrationSettingData = (payload) => ({
  type: actionTypes.SAVE_POS_INTEGRATION_SETTING_DATA,
  payload,
});
export const getApplicableModule = (query) => ({
  type: actionTypes.GET_APPLICABLE_MODULE,
  query,
});
export const saveApplicableModule = (payload) => ({
  type: actionTypes.SAVE_APPLICABLE_MODULE,
  payload,
});

export const getFrequency = (query) => ({
  type: actionTypes.GET_FREQUENCY,
  query,
});

export const saveFrequency = (payload) => ({
  type: actionTypes.SAVE_FREQUENCY,
  payload,
});

// layout master
export const getRoomsLayoutData = (payload) => ({
  type: actionTypes.GET_ROOMS_LAYOUT_DATA,
  payload,
});

export const saveRoomsLayoutData = (payload) => ({
  type: actionTypes.SAVE_ROOMS_LAYOUT_DATA,
  payload,
});

export const postAddRoomLayout = (payload) => ({
  type: actionTypes.POST_ADD_ROOM_LAYOUT,
  payload,
});
export const getEditRoomLayout = (query) => ({
  type: actionTypes.GET_EDIT_ROOM_LAYOUT,
  query,
});

export const postEditRoomLayout = (payload) => ({
  type: actionTypes.POST_EDIT_ROOM_LAYOUT,
  payload,
});
export const saveEditRoomLayout = (payload) => ({
  type: actionTypes.SAVE_EDIT_ROOM_LAYOUT,
  payload,
});

export const deleteRoomLayout = (query) => ({
  type: actionTypes.DELETE_ROOM_LAYOUT,
  query,
});

// Table master
export const getTableMasterData = (payload) => ({
  type: actionTypes.GET_TABLE_MASTER_DATA,
  payload,
});

export const saveTableMasterData = (payload) => ({
  type: actionTypes.SAVE_TABLE_MASTER_DATA,
  payload,
});

export const getEditTableMasterFormData = (payload) => ({
  type: actionTypes.GET_EDIT_TABLE_MASTER_FORM_DATA,
  payload,
});
export const saveEditTableMasterFormData = (payload) => ({
  type: actionTypes.SAVE_EDIT_TABLE_MASTER_FORM_DATA,
  payload,
});
export const postEditTableMasterFormData = (payload) => ({
  type: actionTypes.POST_EDIT_TABLE_MASTER_FORM_DATA,
  payload,
});

export const getTableMasterFormData = (payload) => ({
  type: actionTypes.GET_TABLE_MASTER_FORM_DATA,
  payload,
});
export const saveTableMasterFormData = (payload) => ({
  type: actionTypes.SAVE_TABLE_MASTER_FORM_DATA,
  payload,
});
export const postAddTableMasterFormData = (payload) => ({
  type: actionTypes.POST_ADD_TABLE_MASTER_FORM_DATA,
  payload,
});

export const postAddRoomInForm = (payload) => ({
  type: actionTypes.POST_ADD_ROOM_IN_FORM,
  payload,
});

// hardware master
export const getHardwareMasterData = (payload) => ({
  type: actionTypes.GET_HARDWARE_MASTER_DATA,
  payload,
});
export const postHardwareMasterData = (payload) => ({
  type: actionTypes.POST_HARDWARE_MASTER_DATA,
  payload,
});

export const saveHardwareMasterData = (payload) => ({
  type: actionTypes.SAVE_HARDWARE_MASTER_DATA,
  payload,
});
export const getHardwareMasterFormData = (payload) => ({
  type: actionTypes.GET_HARDWARE_MASTER_FORM_DATA,
  payload,
});
export const saveHardwareMasterFormData = (payload) => ({
  type: actionTypes.SAVE_HARDWARE_MASTER_FORM_DATA,
  payload,
});

export const setHardwareModel = (payload) => ({
  type: actionTypes.SET_HARDWARE_MODEL,
  payload,
});
export const setHardwareMaker = (payload) => ({
  type: actionTypes.SET_HARDWARE_MAKER,
  payload,
});
export const getQualificationSelection = (payload) => ({
  type: actionTypes.GET_QUALIFICATION_SELECTION,
  payload,
});
export const saveQualificationSelection = (payload) => ({
  type: actionTypes.SAVE_QUALIFICATION_SELECTION,
  payload,
});

export const getEditHardwareMasterData = (payload) => ({
  type: actionTypes.GET_EDIT_HARDWARE_MASTER_DATA,
  payload,
});
export const saveEditHardwareMasterData = (payload) => ({
  type: actionTypes.SAVE_EDIT_HARDWARE_MASTER_DATA,
  payload,
});
export const postEditHardwareMasterData = (payload) => ({
  type: actionTypes.POST_EDIT_HARDWARE_MASTER_DATA,
  payload,
});

export const getHardwareDetailsSession = (payload) => ({
  type: actionTypes.GET_HARDWARE_DETAILS_SESSION,
  payload,
});

export const saveHardwareDetailsSession = (payload) => ({
  type: actionTypes.SAVE_HARDWARE_DETAILS_SESSION,
  payload,
});

export const postHardwareDetailsSession = (payload) => ({
  type: actionTypes.POST_HARDWARE_DETAILS_SESSION,
  payload,
});

export const setModalState = (payload) => ({
  type: actionTypes.SET_MODAL_STATE,
  payload,
});

export const setFormState = (payload) => ({
  type: actionTypes.SET_FORM_STATE,
  payload,
});

export const getInventoryGeneralSettingsData = (payload) => ({
  type: actionTypes.GET_INVENTORY_GENERAL_SETTINGS_DATA,
  payload,
});

export const saveInventoryGeneralSettingsData = (payload) => ({
  type: actionTypes.SAVE_INVENTORY_GENERAL_SETTINGS_DATA,
  payload,
});

export const postInventoryGeneralSettingsData = (payload) => ({
  type: actionTypes.POST_INVENTORY_GENERAL_SETTINGS_DATA,
  payload,
});
export const getInventoryCountSettingsData = (payload) => ({
  type: actionTypes.GET_INVENTORY_COUNT_SETTINGS_DATA,
  payload,
});

export const saveInventoryCountSettingsData = (payload) => ({
  type: actionTypes.SAVE_INVENTORY_COUNT_SETTINGS_DATA,
  payload,
});

export const postAddInventoryCountSettingsData = (payload) => ({
  type: actionTypes.POST_ADD_INVENTORY_COUNT_SETTINGS_DATA,
  payload,
});

export const postGeneralCountSettings = (payload) => ({
  type: actionTypes.POST_GENERAL_COUNT_SETTINGS,
  payload,
});

export const deleteInventoryCountSettingsData = (payload) => ({
  type: actionTypes.DELETE_INVENTORY_COUNT_SETTINGS_DATA,
  payload,
});

export const getEditInventoryCountSettingsData = (payload) => ({
  type: actionTypes.GET_EDIT_INVENTORY_COUNT_SETTINGS_DATA,
  payload,
});

export const saveEditInventoryCountSettingsData = (payload) => ({
  type: actionTypes.SAVE_EDIT_INVENTORY_COUNT_SETTINGS_DATA,
  payload,
});

export const postEditInventoryCountSettingsData = (payload) => ({
  type: actionTypes.POST_EDIT_INVENTORY_COUNT_SETTINGS_DATA,
  payload,
});

export const getLabourAddEmployeeFormData = (payload) => ({
  type: actionTypes.GET_LABOUR_ADD_EMPLOYEE_FORM_DATA,
  payload,
});

export const saveLabourAddEmployeeFormData = (payload) => ({
  type: actionTypes.SAVE_LABOUR_ADD_EMPLOYEE_FORM_DATA,
  payload,
});

export const postLabourAddEmployeeFormData = (payload) => ({
  type: actionTypes.POST_LABOUR_ADD_EMPLOYEE_FORM_DATA,
  payload,
});

export const getLabourEmployeeList = (payload) => ({
  type: actionTypes.GET_LABOUR_EMPLOYEE_LIST,
  payload,
});

export const saveLabourEmployeeList = (payload) => ({
  type: actionTypes.SAVE_LABOUR_EMPLOYEE_LIST,
  payload,
});

export const getEditLabourEmployeeData = (payload) => ({
  type: actionTypes.GET_EDIT_LABOUR_EMPLOYEE_DATA,
  payload,
});

export const saveEditLabourEmployeeData = (payload) => ({
  type: actionTypes.SAVE_EDIT_LABOUR_EMPLOYEE_DATA,
  payload,
});

export const postEditLabourEmployeeData = (payload) => ({
  type: actionTypes.POST_EDIT_LABOUR_EMPLOYEE_DATA,
  payload,
});

export const getEmployeeBankingInfo = (payload) => ({
  type: actionTypes.GET_EMPLOYEE_BANKING_INFO,
  payload,
});

export const saveEmployeeBankingInfo = (payload) => ({
  type: actionTypes.SAVE_EMPLOYEE_BANKING_INFO,
  payload,
});

export const postEmployeeBankingInfo = (payload) => ({
  type: actionTypes.POST_EMPLOYEE_BANKING_INFO,
  payload,
});

export const deleteEmployeeBankingInfo = (payload) => ({
  type: actionTypes.DELETE_EMPLOYEE_BANKING_INFO,
  payload,
});

export const getEmployeeDocumentInfo = (payload) => ({
  type: actionTypes.GET_EMPLOYEE_DOCUMENT_INFO,
  payload,
});

export const saveEmployeeDocumentInfo = (payload) => ({
  type: actionTypes.SAVE_EMPLOYEE_DOCUMENT_INFO,
  payload,
});

export const postEmployeeDocumentInfo = (payload) => ({
  type: actionTypes.POST_EMPLOYEE_DOCUMENT_INFO,
  payload,
});

export const deleteEmployeeDocumentInfo = (payload) => ({
  type: actionTypes.DELETE_EMPLOYEE_DOCUMENT_INFO,
  payload,
});

export const getEmployeeTaxDocumentInfo = (payload) => ({
  type: actionTypes.GET_EMPLOYEE_TAX_DOCUMENT_INFO,
  payload,
});

export const saveEmployeeTaxDocumentInfo = (payload) => ({
  type: actionTypes.SAVE_EMPLOYEE_TAX_DOCUMENT_INFO,
  payload,
});

export const postEmployeeTaxDocumentInfo = (payload) => ({
  type: actionTypes.POST_EMPLOYEE_TAX_DOCUMENT_INFO,
  payload,
});

export const deleteEmployeeTaxDocumentInfo = (payload) => ({
  type: actionTypes.DELETE_EMPLOYEE_TAX_DOCUMENT_INFO,
  payload,
});

export const getEmployeeDependentsInfo = (payload) => ({
  type: actionTypes.GET_EMPLOYEE_DEPENDENTS_INFO,
  payload,
});

export const saveEmployeeDependentsInfo = (payload) => ({
  type: actionTypes.SAVE_EMPLOYEE_DEPENDENTS_INFO,
  payload,
});

export const postEmployeeDependentsInfo = (payload) => ({
  type: actionTypes.POST_EMPLOYEE_DEPENDENTS_INFO,
  payload,
});

export const deleteEmployeeDependentsInfo = (payload) => ({
  type: actionTypes.DELETE_EMPLOYEE_DEPENDENTS_INFO,
  payload,
});

export const getClipBoardData = (payload) => ({
  type: actionTypes.GET_CLIPBOARD_DATA,
  payload,
});
export const saveClipBoardData = (payload) => ({
  type: actionTypes.SAVE_CLIPBOARD_DATA,
  payload,
});
export const postClipBoardData = (payload) => ({
  type: actionTypes.POST_CLIPBOARD_DATA,
  payload,
});

export const postClipBoardDescription = (payload) => ({
  type: actionTypes.POST_CLIPBOARD_DESCRIPTION,
  payload,
});

export const deleteClipBoardDescription = (payload) => ({
  type: actionTypes.DELETE_CLIPBOARD_DESCRIPTION,
  payload,
});

export const getPromotions = (payload) => ({
  type: actionTypes.GET_PROMOTIONS,
  payload,
});

export const savePromotions = (payload) => ({
  type: actionTypes.SAVE_PROMOTIONS,
  payload,
});
export const deletePromotion = (payload) => ({
  type: actionTypes.DELETE_PROMOTION,
  payload,
});

export const getPromotionsFormData = (payload) => ({
  type: actionTypes.GET_PROMOTIONS_FORM_DATA,
  payload,
});

export const savePromotionsFormData = (payload) => ({
  type: actionTypes.SAVE_PROMOTIONS_FORM_DATA,
  payload,
});
export const postAddPromotionData = (payload) => ({
  type: actionTypes.POST_ADD_PROMOTION_DATA,
  payload,
});

export const postPromotionApplicationData = (payload) => ({
  type: actionTypes.POST_PROMOTION_APPLICATION_DATA,
  payload,
});

export const savePromotionApplicationData = (payload) => ({
  type: actionTypes.SAVE_PROMOTION_APPLICATION_DATA,
  payload,
});

export const getEditPromotionData = (payload) => ({
  type: actionTypes.GET_EDIT_PROMOTION_DATA,
  payload,
});

export const saveEditPromotionData = (payload) => ({
  type: actionTypes.SAVE_EDIT_PROMOTION_DATA,
  payload,
});

export const postEditPromotionData = (payload) => ({
  type: actionTypes.POST_EDIT_PROMOTION_DATA,
  payload,
});

export const postPromoGroup = (payload) => ({
  type: actionTypes.POST_PROMO_GROUP,
  payload,
});

export const savePromoGroup = (payload) => ({
  type: actionTypes.SAVE_PROMO_GROUP,
  payload,
});

export const editPromotionPeriod = (payload) => ({
  type: actionTypes.EDIT_PROMOTION_PERIOD,
  payload,
});
export const addPromotionPeriod = (payload) => ({
  type: actionTypes.ADD_PROMOTION_PERIOD,
  payload,
});
export const getAddPromotionPeriodData = (payload) => ({
  type: actionTypes.GET_ADD_PROMOTION_PERIOD_DATA,
  payload,
});
export const savePromotionPeriod = (payload) => ({
  type: actionTypes.SAVE_PROMOTION_PERIOD,
  payload,
});
export const deletePromotionPeriod = (payload) => ({
  type: actionTypes.DELETE_PROMOTION_PERIOD,
  payload,
});

export const getQualificationCriteria = (payload) => ({
  type: actionTypes.GET_QUALIFICATION_CRITERIA,
  payload,
});
export const saveQualificationCriteria = (payload) => ({
  type: actionTypes.SAVE_QUALIFICATION_CRITERIA,
  payload,
});
export const postQualificationCriteria = (payload) => ({
  type: actionTypes.POST_QUALIFICATION_CRITERIA,
  payload,
});

export const getMenuPricingDetails = (payload) => ({
  type: actionTypes.GET_MENU_PRICING_DETAILS,
  payload,
});
export const saveMenuPricingDetails = (payload) => ({
  type: actionTypes.SAVE_MENU_PRICING_DETAILS,
  payload,
});
export const postMenuPricingDetails = (payload) => ({
  type: actionTypes.POST_MENU_PRICING_DETAILS,
  payload,
});

export const getScheduledMenuPricingDetails = (payload) => ({
  type: actionTypes.GET_SCHEDULED_MENU_PRICING_DETAILS,
  payload,
});
export const saveScheduledMenuPricingDetails = (payload) => ({
  type: actionTypes.SAVE_SCHEDULED_MENU_PRICING_DETAILS,
  payload,
});
export const postScheduledMenuPricingDetails = (payload) => ({
  type: actionTypes.POST_SCHEDULED_MENU_PRICING_DETAILS,
  payload,
});
export const searchMenuByName = (payload) => ({
  type: actionTypes.SEARCH_MENU_BY_NAME,
  payload,
});

export const saveSearchMenuResult = (payload) => ({
  type: actionTypes.SAVE_SEARCH_MENU_RESULT,
  payload,
});
export const getSalesType = (payload) => ({
  type: actionTypes.GET_SALES_TYPE,
  payload,
});
export const saveSalesType = (payload) => ({
  type: actionTypes.SAVE_SALES_TYPE,
  payload,
});
export const deleteScheduleMenuItem = (payload) => ({
  type: actionTypes.DELETE_SCHEDULED_MENU_ITEM,
  payload,
});

export const saveEditScheduledMenuItem = (payload) => ({
  type: actionTypes.SAVE_EDIT_SCHEDULED_MENU_ITEM,
  payload,
});
